export default function CardRectangle({title, description}) {
    return (
        <div className="flex justify-content-start align-items-center kedual-frame rectangle-13 m-1">
            <div className="flex justify-content-start align-items-center kedual-frame rectangle-14">
                <div className="flex justify-content-start kedual-frame rectangle-15">
                    <div className="flex flex-row justify-content-start align-items-center gap-075 pl-3 pr-4">
                        <div className="flex keduall-typography heading-h0-medium-500 text-white-txt" style={{padding: '1rem'}}>{title}</div>
                        <div className="flex keduall-typography heading-h5-semibold-600 text-white-txt">{description}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}